// export const saveToken = (token) => {
//   const isProd = window.location.hostname !== "localhost";

//   document.cookie = `userToken=${token}; path=/; ${
//     isProd ? "Secure;" : ""
//   } SameSite=Lax`;
//   document.cookie = `isAuthenticated=true; path=/; ${
//     isProd ? "Secure;" : ""
//   } SameSite=Lax`;
// };

export const saveToken = (token) => {
  // Prefer JWT exp claim if present; fallback to 24h when missing/invalid.
  const expiryTime =
    getJwtExpiryTime(token) || Date.now() + 24 * 60 * 60 * 1000;

  // Store the token and related info in session storage
  sessionStorage.setItem("userToken", token);
  sessionStorage.setItem("tokenExpiry", expiryTime);
  sessionStorage.setItem("isAuthenticated", "true");

  const tokenPreview =
    typeof token === "string"
      ? token.substring(0, 15) + "..."
      : "invalid-token";
  console.log("Token saved successfully", { token: tokenPreview, expiryTime });
};

const getJwtExpiryTime = (token) => {
  if (typeof token !== "string") {
    return null;
  }

  const parts = token.split(".");
  if (parts.length !== 3) {
    return null;
  }

  try {
    // Decode base64url payload safely in browser.
    const payloadBase64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = payloadBase64.padEnd(
      payloadBase64.length + ((4 - (payloadBase64.length % 4)) % 4),
      "=",
    );
    const payloadJson = atob(paddedPayload);
    const payload = JSON.parse(payloadJson);

    if (typeof payload.exp !== "number") {
      return null;
    }

    // JWT exp is in seconds since epoch.
    return payload.exp * 1000;
  } catch (error) {
    return null;
  }
};

export const removeToken = () => {
  sessionStorage.removeItem("userToken");
  sessionStorage.removeItem("isAuthenticated");
  sessionStorage.removeItem("tokenExpiry");
};
